import React, {Component} from "react";
import {Link} from "react-router-dom";

class AboutArea extends Component {
    render() {
        const imagePart = (
            <div className="col-lg-6 col-md-8">
                <div className="pr-0 pr-lg-5">
                    <img className="img-fluid" src={process.env.PUBLIC_URL + '/assets/images/myrtlebeach.jpg'} alt="about" />
                </div>
            </div>
        );

        const descPart = (
            <div className="col-lg-6 col-md-10">
                <div className={this.props.design === 'home_1' ? 'block text-center mt-5 mt-lg-0' : 'block'}>
                    <h2 className="h1 text-dark">Dedicated to Providing the Grand Strand With The Best Computer and Mobile Repair Solutions For Over 10 Years</h2>
                    <p className="mt-25">Whether you need to repair a cracked phone screen, remove a virus from your computer, or you have virtually any other IT repair need, we have you covered.</p>
                    <p className="mt-25">
                    Additionally, we specialize in managed IT services for small-to-medium sized business. At iScreenFix, we offer the following services to residents, visitors and business owners in the Myrtle Beach area: Data services, iPhone Repair, tablet, laptop, PC, network, internet, IT Service desk, RMM (Remote Management).
                    </p>
                    <Link to={'/services'} className="btn btn-primary mt-30 initiate-scripts">learn more</Link>
                </div>
            </div>
        )
        return (
            <section className={this.props.design === 'home_1' ? 'section cm-about-us pt-80' : 'section cm-about-us'}>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        {this.props.design === 'home_1' ? (
                            <>
                                {imagePart}
                                {descPart}
                            </>
                        ) : (
                            <>
                                {descPart}
                                {imagePart}
                            </>
                        )}
                    </div>
                </div>
            </section>
        );
    }
}

export default AboutArea;